import React from 'react';
import { Box, Text } from '@razorpay/blade/components';

export const DetailRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <Box display="flex" gap="spacing.4" marginBottom="spacing.3">
    <Box width="45%">
      <Text color="surface.text.gray.muted" size="medium">
        {label}
      </Text>
    </Box>
    <Box flexGrow={1}>{children}</Box>
  </Box>
);
